import { PaymentStatus } from '../stock/stock.type';

/** 'Payed'/'NotPayed' -> 'status-payed'/'status-notpayed'. Also used for settlement status. */
export function statusClass(status: string): string {
  return `status-${status.toLowerCase()}`;
}

export function paymentLabel(status: PaymentStatus | string): string {
  return status === 'Payed' ? 'Paid' : 'Unpaid';
}
